import { render, staticRenderFns } from "./select-task-level.vue?vue&type=template&id=4cbe5754&scoped=true&"
import script from "./select-task-level.vue?vue&type=script&lang=js&"
export * from "./select-task-level.vue?vue&type=script&lang=js&"
import style0 from "./select-task-level.vue?vue&type=style&index=0&id=4cbe5754&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cbe5754",
  null
  
)

export default component.exports